export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden [clip-path:ellipse(120%_100%_at_50%_0%)]">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20intimate%20Italian%20restaurant%20interior%20with%20golden%20ambient%20lighting%2C%20wooden%20tables%20with%20crisp%20white%20tablecloths%2C%20sparkling%20wine%20glasses%2C%20flickering%20candles%2C%20lush%20green%20potted%20plants%2C%20rustic%20exposed%20brick%20wall%2C%20cream%20walls%2C%20elegant%20yet%20cozy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20interior%20photography%2C%20warm%20cream%20and%20terracotta%20tones&width=1800&height=1000&seq=hero-italian-restaurant-01&orientation=landscape"
        alt="Trattoria Sole 温もりのあるイタリアンレストラン店内"
        title="Trattoria Sole 店内の雰囲気"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full flex flex-col justify-center items-center w-full">
      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 flex justify-center">
      <div className="max-w-xl text-center">

            <h1 className="text-white text-5xl md:text-7xl lg:text-8xl font-heading font-bold leading-[1.05] mb-4 [text-shadow:0_0_10px_rgba(0,0,0,0.9),0_0_20px_rgba(0,0,0,0.7),0_2px_4px_rgba(0,0,0,0.9)]">
              薪窯の炎と<br />
              手作りパスタ
            </h1>

            <p className="text-white/90 text-base md:text-lg leading-relaxed max-w-md mb-10 [text-shadow:0_0_10px_rgba(0,0,0,0.9),0_0_20px_rgba(0,0,0,0.7),0_2px_4px_rgba(0,0,0,0.9)]">
              恵比寿の路地裏に佇む、とっておきのイタリアン。<br />
              旬の食材と炎が織りなす、特別なひとときを。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm tracking-wide hover:bg-primary-600 transition-all duration-300 hover:scale-105"
              >
                ご予約はこちら
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#about" className="text-white/50 hover:text-white transition-colors">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-2xl"></i>
          </div>
        </a>
      </div>
    </section>
  );
}